export default __webpack_public_path__ + "static/media/Doctor_male_icon.fa78a862.svg";